module.exports = __webpack_public_path__ + "img/zeroFive.25556738.png";